import React, { useEffect, useRef } from 'react'

export default function LandingPopup({ url, onClose }) {
    const containerRef = useRef(null)

    useEffect(() => {
        async function loadExternalPage() {
            try {
                const res = await fetch(url)
                const html = await res.text()

                const container = containerRef.current
                if (!container) return

                const shadow = container.attachShadow({ mode: 'open' })

                const parser = new DOMParser()
                const doc = parser.parseFromString(html, 'text/html')

                doc.querySelectorAll('style').forEach(style => {
                    const newStyle = document.createElement('style')

                    let css = style.textContent
                    css = css.replaceAll(':root', ':host')

                    newStyle.textContent = css
                    shadow.appendChild(newStyle)
                })

                const wrapper = document.createElement('div')
                wrapper.innerHTML = doc.body.innerHTML
                shadow.appendChild(wrapper)

                window.gtag?.('event', 'landing_popup_view', {
                    event_category: 'landing_popup',
                    event_label: 'view'
                })

                // Google Analytics tracking
                shadow.addEventListener('click', (e) => {

                    const closeBtn = e.target.closest('.aubrey-close')
                    const subscribeBtn = e.target.closest('.aubrey-unlock')

                    if (closeBtn) {
                        window.gtag?.('event', 'landing_popup_close_click', {
                            event_category: 'landing_page_popup',
                            event_label: 'close_button'
                        })
                    }

                    if (subscribeBtn) {
                        window.gtag?.('event', 'landing_popup_unlock_click', {
                            event_category: 'landing_page_popup',
                            event_label: 'subscribe_button'
                        })
                        window.location.pathname = '/register'
                    }

                    onClose()
                })

                const scripts = doc.querySelectorAll('script')

                scripts.forEach(script => {
                    if (script.src) {
                        const newScript = document.createElement('script')
                        newScript.src = script.src
                        shadow.appendChild(newScript)
                    } else {
                        try {

                            let code = script.textContent

                            // redirect DOM queries to shadow root
                            code = code.replaceAll('document.', 'shadowRoot.')

                            // fix document.documentElement access
                            code = code.replaceAll(
                                'shadowRoot.documentElement',
                                'document.documentElement'
                            )

                            // React already loaded the page, so load event won't fire
                            code = code.replace(
                                /window\.addEventListener\(['']load[''],\s*function\s*\(\)\s*\{/,
                                '(function(){'
                            )

                            const fn = new Function(
                                'shadowRoot',
                                'window',
                                'document',
                                code
                            )

                            fn(shadow, window, document)

                        } catch (e) {
                            console.error('Script execution error:', e)
                        }
                    }
                })

            } catch (error) {
                console.error('Failed to load page:', error)
            }
        }

        loadExternalPage()
    }, [url])

    return (
        <div
            id='external-page-popup'
            ref={containerRef}
        />
    )
}
